<template>
  <div class='EnbNave01'
  :style="{ 
    backgroundColor: Prefes.nave.corBackground,
    fontFamily: Prefes.nave.font,
    color: Prefes.nave.corFont,
    fontStyle: parseInt(Prefes.nave.fontStyle) ? 'italic' : '',
    fontWeight: parseInt(Prefes.nave.fontBold) ? 'bold' : '',
    textDecoration: parseInt(Prefes.nave.textDecoration) ? 'underline' : '',
    fontSize: Prefes.nave.fontHeight + 'px'
  }"
  >
    <div class="cont-top" :style="{ width: pref ? '95%' : '75%' }">
      <enb-logo01 class="logo"/>
      <div class="cont-links">
        <enb-link01
        v-for="(l, key) in LinksTheme01"
        :key="key"
        :data="l"
        v-model:showsubnave="showsubnave"
        >
          <sub-nave v-if="l.text === 'Produtos'" :show="showsubnave"/>
        </enb-link01>
      </div>
      <div class="icons">
        <div class="cont-link-profile">
          <user-icon01 :color="Prefes.nave.corFont"/>
          <label class="myAccount"
          @click="toProfile"
          >
            {{ !Object.keys(Profile).length ? 'login' : 'Minha Conta' }}
          </label>
        </div>
        <div class="cont-icon-search">
          <search-icon01 :color="Prefes.nave.corFont" @click="ToggleSearch01(true)"/>
        </div>
      </div>
    </div>
    <cart-btn v-if="!pref" @click="ToggleCheckout01(true)"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EnbLogo01 from './EnbLogo01.vue'
import EnbLink01 from './EnbLink01.vue'
import SearchIcon01 from '../Icons/SearchIcon01'
import SubNave from './SubNave'
import CartBtn from '../Checkout/CartBtn'
import UserIcon01 from '../Icons/UserIcon01'
export default {
  name: 'EnbNave01',
  components: { EnbLogo01, EnbLink01, SearchIcon01, SubNave, CartBtn, UserIcon01 },
  props: {
    pref: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      ShowProfileLink: false,
      showsubnave: false
    }
  },
  computed: {
    ...mapGetters(['LinksTheme01', 'Profile', 'Prefes'])
  },
  methods: {
    ...mapActions(['ToggleCheckout01', 'ToggleSearch01', 'SetModal01', 'GetCategory']),
    toProfile() {
      if(Object.keys(this.Profile).length) {
        this.$router.push('/profile')
      } else {
        this.SetModal01({ component: 'EnbLogin01', active: true })
      }
    }
  },
  created () {
    this.GetCategory()
  }
}
</script>

<style scoped>
.EnbNave01 {
  width: 100%;
  height: 100px;
  background-color: #EEEEEE;
}

.cont-top {
  display: flex;
  width: 75%;
  height: 100%;
  margin: auto;
}

.logo {
  width: 220px;
  height: 100%;
  flex-shrink: 0;
}

.logo :deep(img) {
  width: 220px;
  height: 80px;
  object-fit: contain;
}

.cont-links {
  width: 60%;
  display: flex;
}

.icons {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}

.cont-link-profile {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50%;
}

.myAccount {
  display: block;
  font-size: 14px;
  line-height: 100%;
  cursor: pointer;
}

.cont-icon-search {
  display: flex;
  align-items: center;
  cursor: pointer;
}

@media (max-width: 500px) {
  .EnbNave01 {
    display: none;
  }
}
</style>
